import axios from "axios";
import { BACKEND_URL } from "./Constants";
import {
  validateEmail,
  validateEmailOtp,
  validatePhone,
  validatePhoneOtp,
  phoneSignup,
  emailSignup,
  phoneSignin,
  emailSignin,
  refreshAccessTokenMutation,
  updatePassword,
  forgotPasswordPhoneMutation,
  forgotPasswordEmailMutation,
  resetPasswordPhoneMutation,
  resetPasswordEmailMutation,
} from "./mutations";
import { getMe } from "./queries";

export const sendOtpPhone = async (phoneNumber) => {
  const response = await axios.post(BACKEND_URL, validatePhone(phoneNumber));
  console.log(phoneNumber);
  return response.data;
};

export const sendOtpEmail = async (email) => {
  const response = await axios.post(BACKEND_URL, validateEmail(email));
  return response.data;
};

export const validateOtpPhone = async (phoneNumber, otp) => {
  const response = await axios.post(
    BACKEND_URL,
    validatePhoneOtp(phoneNumber, otp)
  );
  return response.data;
};

export const validateOtpEmail = async (email, otp) => {
  const response = await axios.post(BACKEND_URL, validateEmailOtp(email, otp));
  return response.data;
};

export const phoneSignUp = async (phone, password, otpValidationToken) => {
  const response = await axios.post(
    BACKEND_URL,
    phoneSignup(phone, password, otpValidationToken)
  );
  return response.data;
};

export const getMyProfile = async (accessToken) => {
  const response = await axios.post(BACKEND_URL, getMe(accessToken));
  return response.data;
};

export const emailSignUp = async (email, password, otpValidationToken) => {
  const response = await axios.post(
    BACKEND_URL,
    emailSignup(email, password, otpValidationToken)
  );
  return response.data;
};

export const phoneSignIn = async (phone, password) => {
  const response = await axios.post(BACKEND_URL, phoneSignin(phone, password));
  return response;
};

export const emailSignIn = async (email, password) => {
  const response = await axios.post(BACKEND_URL, emailSignin(email, password));
  return response;
};

export const refreshAccessToken = async (accessToken) => {
  const response = await axios.post(
    BACKEND_URL,
    refreshAccessTokenMutation(accessToken)
  );
  return response.data.data.refreshAccessToken;
};

export const changePassword = async (accessToken, oldPassword, newPassword) => {
  const response = await axios.post(
    BACKEND_URL,
    updatePassword(accessToken, oldPassword, newPassword)
  );
  return response.data;
};

export const forgotPasswordPhone = async (phoneNumber) => {
  const response = await axios.post(
    BACKEND_URL,
    forgotPasswordPhoneMutation(phoneNumber)
  );
  return response.data;
};

export const forgotPasswordEmail = async (email) => {
  const response = await axios.post(
    BACKEND_URL,
    forgotPasswordEmailMutation(email)
  );
  return response.data;
};

export const resetPassword = async (token, password, type) => {
  let mutation =
    type === "phone"
      ? resetPasswordPhoneMutation(token, password)
      : resetPasswordEmailMutation(token, password);
  const response = await axios.post(BACKEND_URL, mutation);
  return response.data;
};
